export default __webpack_public_path__ + "static/media/mine.min.c78d0bec.png";